<template>
  <form v-if="value">
    <string-form-field
      label="Nome"
      :value="value.name"
      :disabled="disabled"
      :error="findError('name')"
      @input="propertyChanged('name', $event)"
    />
  </form>
</template>
<script>
import EntityEditorMixin from 'vue-core/mixins/EntityEditorMixin';

export default {
  mixins: [ EntityEditorMixin ],
}
</script>
